import { COLOR, VARIANT } from './types'
import { useMemo } from 'react'

export const useBorder = (color: COLOR, variant: VARIANT) => {
  return useMemo(
    () => (variant === 'outline' ? `border-${color}` : ''),
    [color, variant],
  )
}
